var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "CHECK_OUT",
    "data-name": "CHECK OUT",
    d: "M1.71,6H9.835a.5.5,0,1,1,0,1H1.71L2.856,8.146a.5.5,0,0,1-.707.707l-2-2a.5.5,0,0,1,0-.707l2-2a.5.5,0,1,1,.707.707L1.709,6h0ZM11.836,0H6.5A1.168,1.168,0,0,0,5.336,1.167V2.5a.5.5,0,1,0,1,0V1.167A.167.167,0,0,1,6.5,1h5.333A.167.167,0,0,1,12,1.167V11.833a.167.167,0,0,1-.167.167H6.5a.167.167,0,0,1-.167-.167V10.5a.5.5,0,0,0-1,0v1.333A1.168,1.168,0,0,0,6.5,13h5.333A1.168,1.168,0,0,0,13,11.833V1.167A1.168,1.168,0,0,0,11.836,0Z",
    transform: "translate(-0.003)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/checkOut.15cf9086df97ac48c62f0a5aa4bfb9ae.svg";
export { ForwardRef as ReactComponent };